/** A number of listings as a seller reads it: "1 listing", "3 listings". */
export const listingsWord = (n) => `${n} listing${n === 1 ? '' : 's'}`;
